import React from "react";
import {
  BookOpen,
  Activity,
  Percent,
  Clock,
  GraduationCap,
  Flag,
} from "lucide-react";

const icons = {
  activity: Activity,
  score: Flag,
  time: Clock,
  courses: GraduationCap,
};

const StatCard = ({
  title,
  value,
  icon = "courses",
  color = "bg-orange-100",
  textColor = "text-orange-500",
}) => {
  const IconComponent = icons[icon] || BookOpen;

  return (
    <div className="bg-white shadow-sm border rounded-lg px-6 py-3 w-full">
      <div className="flex items-center gap-1">
        <div className={`inline-block p-2 rounded-md ${color}`}>
          <IconComponent className={`w-5 h-5 ${textColor}`} />
        </div>
        <p className="text-sm text-gray-600 font-medium m-0">{title}</p>
      </div>

      <p className="text-2xl font-semibold text-gray-800 mt-1 ms-2">{value}</p>
    </div>
  );
};

export default StatCard;
